__turbopack_context__.v({
  "cookiesBtnWrapper": "STCookies-module__qBw4ta__cookiesBtnWrapper",
  "cookiesWrapper": "STCookies-module__qBw4ta__cookiesWrapper",
  "slideDown": "STCookies-module__qBw4ta__slideDown",
  "slideUp": "STCookies-module__qBw4ta__slideUp",
  "toggleSwitchList": "STCookies-module__qBw4ta__toggleSwitchList",
});
